/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import * as S from './Faq.style';
import * as T from './Faq.types';

export const Faq: React.FC<T.FaqCollection> = ({ items }) => {
  const [tabSelected, setTabSelected] = React.useState(0);

  return (
    <S.Faq className="section">
      <S.Container>
        <h3>
          Não importa onde você quer vender. O <strong>Direct</strong> ajuda a sua marca a criar uma
          experiência de venda digital e organizada.
        </h3>
        <div className="content">
          {items.map((item, index) => {
            return (
              <div className={`tab ${tabSelected === index ? 'active' : ''}`} key={item.title}>
                <div className="title_tab" onClick={() => setTabSelected(index)}>
                  <span>{item.title}</span>
                </div>
                <div className="text">
                  <div>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="contact">
          <S.Link href="#contato">
            quero vender com Direct
            <ArrowRightIcon />
          </S.Link>
        </div>
      </S.Container>
    </S.Faq>
  );
};
